import { render, staticRenderFns } from "./ChatBoxLocation.vue?vue&type=template&id=48babc75&scoped=true&"
import script from "./ChatBoxLocation.vue?vue&type=script&lang=js&"
export * from "./ChatBoxLocation.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxLocation.vue?vue&type=style&index=0&id=48babc75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48babc75",
  null
  
)

export default component.exports